<div class="forgot-password-page">
  <!-- Arrière-plan animé -->
  <div class="animated-background">
    <!-- Cercles décoratifs animés -->
    <div class="decorative-circles">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="circle circle-5"></div>
    </div>

    <!-- Particules lumineuses -->
    <div class="light-particles">
      <div class="light-particle particle-1"></div>
      <div class="light-particle particle-2"></div>
      <div class="light-particle particle-3"></div>
      <div class="light-particle particle-4"></div>
      <div class="light-particle particle-5"></div>
      <div class="light-particle particle-6"></div>
      <div class="light-particle particle-7"></div>
      <div class="light-particle particle-8"></div>
    </div>

    <!-- Icônes flottantes -->
    <div class="floating-icons">
      <i class="bi bi-shield-lock icon-1"></i>
      <i class="bi bi-envelope-check icon-2"></i>
      <i class="bi bi-key icon-3"></i>
      <i class="bi bi-lock-fill icon-4"></i>
    </div>
  </div>

  <div class="container forgot-password-container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-lg-5 col-md-7 col-sm-9">
        <!-- État initial : Formulaire de demande -->
        <div class="forgot-password-card card-custom fade-in-up" *ngIf="!emailSent">
          <div class="text-center mb-4">
            <div class="icon-wrapper mb-3">
              <i class="bi bi-key-fill"></i>
            </div>
            <h1 class="mb-2">Mot de passe oublié ?</h1>
            <p class="text-secondary">
              Pas de problème ! Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
          </div>

          <!-- Message d'erreur global -->
          <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="errorMessage">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ errorMessage }}
            <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
          </div>

          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <!-- Email -->
            <div class="form-group mb-4">
              <label for="email" class="form-label">
                Adresse email <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon bi bi-envelope"></i>
                <input
                  type="email"
                  id="email"
                  class="form-control custom-input"
                  placeholder="contact@example.com"
                  formControlName="email"
                  [class.is-invalid]="isFieldInvalid('email')"
                />
              </div>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </div>
            </div>

            <!-- Bouton d'envoi -->
            <button
              type="submit"
              class="btn btn-primary-custom w-100 mb-3 justify-content-center align-items-center"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">
                <i class="bi bi-send me-2"></i>
                Envoyer le lien de réinitialisation
              </span>
              <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Envoi en cours...
              </span>
            </button>

            <!-- Retour à la connexion -->
            <div class="text-center">
              <a (click)="navigateToSignin()" class="text-primary-color cursor-pointer">
                <i class="bi bi-arrow-left me-1"></i>
                Retour à la connexion
              </a>
            </div>
          </form>
        </div>

        <!-- État après envoi : Confirmation -->
        <div class="forgot-password-card card-custom fade-in-up" *ngIf="emailSent">
          <div class="text-center">
            <div class="success-icon-wrapper mb-4">
              <i class="bi bi-envelope-check-fill"></i>
            </div>
            <h1 class="mb-3">Email envoyé !</h1>
            <p class="text-secondary mb-4">
              Nous avons envoyé un lien de réinitialisation à
              <strong class="text-primary-color">{{ forgotPasswordForm.get('email')?.value }}</strong>
            </p>

            <!-- Instructions -->
            <div class="instructions-box mb-4">
              <h6 class="mb-3">Prochaines étapes :</h6>
              <ol class="text-start">
                <li class="mb-2">Vérifiez votre boîte de réception</li>
                <li class="mb-2">Cliquez sur le lien dans l'email</li>
                <li class="mb-2">Créez votre nouveau mot de passe</li>
                <li>Connectez-vous avec vos nouveaux identifiants</li>
              </ol>
            </div>

            <!-- Info supplémentaire -->
            <div class="info-box mb-4">
              <i class="bi bi-info-circle me-2"></i>
              <small>Le lien expire dans 24 heures</small>
            </div>

            <!-- Bouton de renvoi -->
            <div class="resend-section mb-4">
              <p class="text-secondary small mb-2">Vous n'avez pas reçu l'email ?</p>
              <button
                type="button"
                class="btn btn-outline-custom"
                (click)="resendEmail()"
                [disabled]="!canResend"
              >
                <span *ngIf="canResend">
                  <i class="bi bi-arrow-clockwise me-2"></i>
                  Renvoyer l'email
                </span>
                <span *ngIf="!canResend">
                  Renvoyer dans {{ countdown }}s
                </span>
              </button>
            </div>

            <!-- Actions -->
            <div class="action-buttons">
              <button class="btn btn-primary-custom me-2" (click)="navigateToSignin()">
                <i class="bi bi-box-arrow-in-right me-2"></i>
                Aller à la connexion
              </button>
              <button class="btn btn-outline-custom" (click)="navigateToSignup()">
                Créer un compte
              </button>
            </div>
          </div>
        </div>

        <!-- Section aide -->
        <div class="help-section text-center mt-4 fade-in">
          <p class="text-secondary small mb-2">
            <i class="bi bi-question-circle me-1"></i>
            Besoin d'aide ?
          </p>
          <div class="help-links">
            <a routerLink="/contact" class="text-primary-color me-3">Support</a>
            <a routerLink="/faqs" class="text-primary-color me-3">FAQ</a>
            <a routerLink="/contact" class="text-primary-color">Nous contacter</a>
          </div>
        </div>

        <!-- Section sécurité -->
        <div class="security-info text-center mt-4 fade-in">
          <p class="text-secondary small mb-0">
            <i class="bi bi-shield-check text-primary-color me-1"></i>
            Vos données sont protégées et confidentielles
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
